<template>
  <div
    id="formDetail"
    class="formSroll"
    :style="{ maxHeight: height ? height + 'px' : '' }"
  >
    <el-descriptions
      :column="column"
      size="medium"
      border
      :contentStyle="CS"
      :labelStyle="LS"
    >
      <template v-for="value in tableConfig.fieldConfig">
        <el-descriptions-item
          :key="value.fieldId"
          v-if="$chargeCondition(value, conditionArr, formData)"
        >
          <template slot="label">
            <el-popover
              v-if="compareData"
              placement="bottom"
              title="对比结果"
              trigger="hover"
              popper-class="popperClass"
              :content="compareData[value.enName].value"
            >
              <template slot="reference">
                <span :title="value.cnName"
                  >{{ value.cnName }}
                  <br />
                  <span
                    :style="{
                      color:
                        compareData[value.enName].type == 2 ? 'red' : '#409EFF',
                    }"
                  >
                    {{
                      compareData[value.enName].type == 2
                        ? "数据不同"
                        : compareData[value.enName].type == 1
                        ? "数据相同"
                        : "字段无需更新"
                    }}
                  </span>
                </span>
              </template>
            </el-popover>
            <span v-else :title="value.cnName">{{ value.cnName }}</span>
          </template>
          <component
            :is="getComponents(value)"
            :data="formData[value.enName]"
            :config="value"
          >
          </component>
        </el-descriptions-item>
      </template>
    </el-descriptions>
    <!-- 表中表逻辑 -->
    <template v-if="isChildTable">
      <ChildTable
        ref="childTable"
        style="margin-top: 10px"
        :config="tableConfig.otherConfig.otherTableConfig"
        :data="formObject.otherTableData"
        operate="3"
      ></ChildTable>
    </template>
  </div>
</template>

<script>
import DateTable from "@/components/formTable/DateTable.vue";
import FileTable from "@/components/formTable/FileTable.vue";
import SelectTable from "@/components/formTable/SelectTable.vue";
import TextTable from "@/components/formTable/TextTable.vue";
import RichTable from "@/components/formTable/RichTable.vue";

// 表中表组件
import ChildTable from "@/pages/formList/components/ChildTable.vue";

export default {
  components: {
    TextTable,
    SelectTable,
    DateTable,
    FileTable,
    RichTable,
    ChildTable,
  },
  name: "FormDetail",
  props: {
    tableConfig: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    height: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    formObject: {
      type: Object,
      default: () => {
        return {};
      },
    },
    column: {
      type: Number,
      default: () => {
        return 3;
      },
    },
    compareData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    isDrawer: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  computed: {
    CS() {
      let width = ((window.innerWidth - 80) * 2) / (this.column * 3);
      return {
        maxWidth: `${this.isDrawer ? width * 0.5 : width}px`,
      };
    },
    LS() {
      let width = (window.innerWidth - 80) / (this.column * 3);
      return {
        maxWidth: `${this.isDrawer ? width * 0.5 : width}px`,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      };
    },
    getComponents() {
      return function (value) {
        if (value.rules.type == "text") {
          return "TextTable";
        } else if (value.rules.type == "date") {
          return "DateTable";
        } else if (value.rules.type == "select") {
          return "SelectTable";
        } else if (value.rules.type == "rich") {
          return "RichTable";
        } else if (value.rules.type == "file") {
          return "FileTable";
        } else {
          return null;
        }
      };
    },
    isChildTable() {
      return (
        Array.isArray(this.formObject.otherTableData) &&
        this.formObject.otherTableData.length > 0
      );
    },
  },
  data() {
    return {
      flowList: [], // 流程信息
      formData: {}, // 表单数值
      conditionArr: {}, // 条件规则
    };
  },
  methods: {
    // 条件规则：联动字段
    initCondition(item) {
      let params = {};
      item.map((res) => {
        res.showField.map((newRes) => {
          if (!params[newRes]) {
            params[newRes] = res.showRules;
          } else {
            if (!(params[newRes] instanceof Array)) {
              params[newRes] = [params[newRes]];
            }
            params[newRes].push(res.showRules);
          }
        });
      });
      this.conditionArr = params;
    },
    // 初始化数据
    initData() {
      if (this.formObject) {
        this.formData = this.$deepClone(this.formObject);
      }
      // 初始化条件
      if (
        this.tableConfig.otherConfig &&
        this.tableConfig.otherConfig.rulesConfig
      ) {
        this.initCondition(this.tableConfig.otherConfig.rulesConfig);
      }
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
